// extracted by mini-css-extract-plugin
export var minimal = "MinimalLayout-module__minimal___UgduV";